import ConsumerViewSvg, { type ConsumerViewSvgProps } from "./ConsumerViewSvg";

/** Buttons use the same drawing primitives with a rectangular body and their front image. */
export default function ButtonViewSvg(props: ConsumerViewSvgProps) {
  return <ConsumerViewSvg {...props} />;
}
